import { SupportInfo } from '@/api/origin-org-svc'
import { serviceProviderService } from '@/utils/apis'

export const getSupportInfo = async (): Promise<
  SupportInfo | null | undefined
> => {
  return await serviceProviderService.findSupportInfo()
}
